import { adminProQueryOptions } from "api/queries/admin";
import { proAvailabilityQueryOptions, proProfileQueryOptions, timeBlocksQueryOptions } from "api/queries/pros";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { id: number; isAdmin: boolean };

export const availabilityQuery = ({ id, isAdmin }: QueriesInput) => proAvailabilityQueryOptions(isAdmin ? id : null);

export const timeBlocksQuery = ({ isAdmin }: QueriesInput) => timeBlocksQueryOptions(isAdmin);

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  adminProQueryOptions(input.id),
  proProfileQueryOptions(input.id),
  availabilityQuery(input),
  timeBlocksQuery(input),
];
